import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Helmet } from 'react-helmet';
import { PORTAL_TYPE } from './types/app.types';
import Main from './components/main/main';
import styleUtils from './styles/style.utils';
import themedColor from './styles/theme/themed-color';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 16px;
  }

  p {
    margin:0;
    padding-bottom:0;
  }  
  
  #ucf-container  {
    * { 
      font-family: ${themedColor('FAMILY')};
      box-sizing: border-box;
      line-height: 1.3em;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
  }
`;

export interface AppProps {
  portal: PORTAL_TYPE;
  utm?: { [p: string]: string };
  activeIcon?: string;
  locale?: string;
  user?: {
    applicant_id?: string;
    company_name?: string;
    title?: string;
    name?: string;
    surname?: string;
    email?: string;
    phone?: string;
  };
  pages?: {
    success?: string;
    success_partner_prospects?: string;
    success_client_prospects?: string;
  };
}

const App: React.FunctionComponent = () => {
  return (
    <AppContainer>
      <Helmet>
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;600;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <GlobalStyle />
      <Main />
    </AppContainer>
  );
};

const AppContainer = styled.div`
  position: relative;
  min-height: ${styleUtils.px(600)};
  display: flex;
  align-items: stretch;
  flex-direction: column;
`;
export default App;
